export const TYPE_LINK = 'link'
export const TYPE_SEPARATOR = 'separator'
export const TYPE_ADD_EVENT = 'add-event'
export const TYPE_WITH_CHILDREN = 'with-children'



/** WEBPACK FOOTER **
 ** ./src/constants/navigation-constants.js
 **/